/**
 * 예약 전 사전 질문 답변 임시 보관소.
 *
 * <p>답변을 받는 곳(모달)과 실제로 서버에 보내는 곳(createBookings)이 화면을 건너
 * 떨어져 있다. 장바구니 → 예약 확인 → 결제로 넘어가는 사이에도 값이 살아 있어야 해서
 * sessionStorage 에 잠깐 둔다. 예약이 만들어지면 지운다.
 */

const KEY = 'kpathport:intakeAnswers';

const readAll = () => {
  try {
    return JSON.parse(sessionStorage.getItem(KEY) ?? '{}');
  } catch {
    return {};
  }
};

const writeAll = (value) => {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(value));
  } catch {
    // 사파리 시크릿 모드 등에서 막힐 수 있다. 답변만 못 나를 뿐 예약은 진행된다
  }
};

/** @param {object} answers questionId → 답변 */
export const saveIntakeAnswers = (workshopId, answers) => {
  if (!workshopId) return;
  writeAll({ ...readAll(), [String(workshopId)]: answers ?? {} });
};

export const loadIntakeAnswers = (workshopId) =>
  readAll()[String(workshopId)] ?? {};

/**
 * createBookings 에 실어 보낼 형태로 만든다.
 *
 * @param {Array<number>} workshopIds 이번에 예약하는 워크숍들
 * @returns [{ workshopId, items: [{ questionId, value }] }]
 */
export const buildAnswersPayload = (workshopIds = []) => {
  const all = readAll();
  return workshopIds
    .filter(Boolean)
    .map((workshopId) => {
      const answers = all[String(workshopId)] ?? {};
      const items = Object.entries(answers)
        .filter(([, value]) => String(value ?? '').trim())
        .map(([questionId, value]) => ({
          questionId: Number(questionId),
          value: String(value).trim(),
        }));
      return items.length ? { workshopId: Number(workshopId), items } : null;
    })
    .filter(Boolean);
};

/**
 * 보관된 답변을 전부 싣는다.
 *
 * <p>어떤 워크숍이 섞여 있는지 화면에서 알기 어려운 곳(결제 페이지)에서 쓴다.
 * 서버는 이번 예약에 해당하는 워크숍 것만 골라 쓰므로 남는 건 그냥 버려진다.
 */
export const buildAllAnswersPayload = () =>
  buildAnswersPayload(Object.keys(readAll()));

export const clearIntakeAnswers = (workshopIds = []) => {
  const all = readAll();
  workshopIds.forEach((workshopId) => delete all[String(workshopId)]);
  writeAll(all);
};

/** 질문 목록에서 답이 없는 필수 항목이 남아 있는지 */
export const hasUnansweredRequired = (questions = [], answers = {}) =>
  questions.some(
    (question) =>
      question.required && !String(answers[question.id] ?? '').trim(),
  );
